// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ResumePromptController from "./resume_prompt_controller"
application.register("resume-prompt", ResumePromptController)

import TimerController from "./timer_controller"
application.register("timer", TimerController)

import RoutineBlocksController from "./routine_blocks_controller"
application.register("routine-blocks", RoutineBlocksController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import AlertsController from "./alerts_controller"
application.register("alerts", AlertsController)

import MobileUnsupportedController from "./mobile_unsupported_controller"
application.register("mobile-unsupported", MobileUnsupportedController)
